import styled from "styled-components";
import { VBabyColors } from "../../../../colors";

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 16px 16px 0 16px;
  width: calc(100% - 32px);

  > p {
    font-family: "Poppins", sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
  }
`;

export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
  min-width: 0;

  & + & {
    border-top: 1px solid ${VBabyColors.gray10};
  }
`;

export const InputsContainer = styled.div`
  padding: 16px;
  flex: 1;
  gap: 16px;
  display: flex;
  flex-direction: column;
  width: calc(100% - 32px);
  min-width: 0;
`;

/* Grid, e não flex com quebra: CEP e estado ficam lado a lado em qualquer largura. */
export const ZipStateRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: start;
  gap: 16px;
`;

export const InlineLinkButton = styled.button`
  padding: 0;
  border: none;
  background: none;
  color: ${VBabyColors.primaryDark};
  font-family: inherit;
  font-size: inherit;
  font-weight: 600;
  line-height: inherit;
  text-align: left;
  text-decoration: underline;
  cursor: pointer;
  touch-action: manipulation;

  &:focus-visible {
    outline: 2px solid ${VBabyColors.primaryDark};
    outline-offset: 2px;
  }
`;
